module.exports = __webpack_public_path__ + "static/media/tdsContent.34289b97.jpg";